import React from "react";
import { Card } from "primereact/card";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import type { OwnerRankingRow } from "../../../../types/targetGroupAnalytics";

interface RankedOwnersTableProps {
  rows: OwnerRankingRow[];
  /** Default top-N shown before truncation indicator (FR-016). */
  topN?: number;
}

/** Admin/global ranked table of top owners by member count (FR-016). Hidden in owner scope. */
const RankedOwnersTable: React.FC<RankedOwnersTableProps> = ({ rows, topN = 25 }) => {
  const total = rows.length;
  const shown = rows.slice(0, topN);
  const truncated = total > topN;

  const header = truncated ? (
    <span className="text-xs text-color-secondary font-normal">
      Top {topN} of {total}
    </span>
  ) : undefined;

  return (
    <Card title="Top owners by members">
      <DataTable
        value={shown}
        size="small"
        sortField="memberCount"
        sortOrder={-1}
        paginator
        rows={10}
        rowsPerPageOptions={[10, 25, 50]}
        emptyMessage="No owners with target groups."
        rowHover
        header={header}
      >
        <Column field="label" header="Owner" sortable style={{ minWidth: "200px" }} />
        <Column field="memberCount" header="Members" sortable style={{ minWidth: "120px" }} />
      </DataTable>
    </Card>
  );
};

export default RankedOwnersTable;
